import Header from "./Header";
import React from "react";
import DOMPurify from "dompurify";
import wordCount from "word-count";
import {
  AddToCartURL,
  FilterList,
  image_url,
  Post,
  ProductsURL,
} from "../utils/api";
import { useEffect, useState } from "react";
import Button from "../component/Button";
import Filter from "./Filter";
import { useNavigate, Link, useParams } from "react-router-dom";
import { wrapComponent } from "react-snackbar-alert";
import { useSelector } from "react-redux";
import CartModal from "../component/cartModal";
import ReactPaginate from "react-paginate";
const ShopPage = ({ createSnackbar }) => {
  const [List, setList] = useState([]);
  const [faq, setfaq] = useState([]);
  const params = useParams();
  const { cartItems, userinfo } = useSelector((state) => state);
  // console.log(cartItems,"from abhishek 22");
  const navigate = useNavigate();

  useEffect(() => {
    fetchItemList();
  }, [params?.searchKey]);

  console.log(params);
  const fetchItemList = (data) => {
    global.Loader(true);
    let body = data ? data : {};
    if (params?.searchKey) {
      body.searchKey = params?.searchKey;
    }

    let config = {
      body: body,
      url: ProductsURL,
    };

    Post(config)
      .then((res) => {
        global.Loader(false);
        console.log(res);
        if (res.status == true) {
          setfaq(res?.faq);
          setList(res?.products);
        }
      })
      .catch((err) => {
        global.Loader(false);
        console.log(err?.response?.data);
      });
  };

  const showSnack = (msg = "", type = "error") => {
    createSnackbar({
      message: msg,
      theme: type,
    });
  };
  const [refres, setrefres] = useState(false);

  const addToCart = ({ qnty = 1, id, varient_id }) => {
    if (userinfo?.token) {
      if (varient_id) {
        global.Loader(true);
        let config = {
          body: {
            product_id: id,
            variant_id: varient_id,
            quantity: qnty,
          },
          url: AddToCartURL,
        };
        Post(config)
          .then((res) => {
            global.Loader(false);
            if (res.status == true) {
              setrefres(!refres);
              showSnack(res?.msg, "success");
              let index = cartItems?.findIndex((v) => v.product_id == id);
              if (index == -1) {
                global.dispatch({
                  type: "CARTITEMS",
                  payload: [...cartItems, { product_id: id }],
                });
              }
            }
          })
          .catch((err) => {
            global.Loader(false);
            console.log(err?.response?.data);
          });
      } else {
        showSnack("Please Select Varient");
      }
    } else {
      showSnack("Please Login");
      navigate("/login");
    }
  };

  // BY Abhishek
  function searchedItems() {
    let filter = params?.searchKey;
    if (filter === undefined) return;

    // title
    if (filter) {
      console.log("from line number 111", filter);

      const newFilterArray = List.filter((l) => {
        return l.title.toLowerCase() === filter;
      });

      console.log(newFilterArray);
    }
  }
  function IterateOverItems({ items }) {
    return (
      <div className="container">
        {items?.map((value) => (
          <div className="gagan">
            <div className="row">
              <div
                className="col-md-3"
                onClick={() => navigate(`/shop/${value.id}`)}
              >
                <div
                  className="active_botal"
                  style={{ position: "absolute", overflow: "hidden" }}
                >
                  <img
                    src={`${image_url}${value?.image}`}
                    alt=""
                    style={{
                      height: "100%",
                      width: "100$",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
                <div className="active_botal1">
                  {/* <img src="/images/latte mix1.png" alt=""/> */}
                </div>
              </div>
              <div
                className="col-md-6"
                onClick={() => navigate(`/shop/${value.id}`)}
              >
                <div className="quality5">
                  <div className="">
                    <h4 style={{ fontSize: "20px" }}>
                      {truncate(value.title, 17)}
                    </h4>
                    {getRating(value.avg_rating)?.map((v, i) =>
                      v == 1 ? (
                        <i className="fa-solid fa-star"></i>
                      ) : (
                        <i className="fa-regular fa-star"></i>
                      )
                    )}
                    {/* <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-regular fa-star"></i> */}{" "}
                    {value.no_of_review}
                    <p>
                      {SafeHTMLRenderer(value.description, 50)}
                    </p>
                    {/* <div className="qualitymix">
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <p>200g x 1 Pkt <i className="fa-solid fa-angle-down"></i><br/> <span>Ortaange mix</span></p>
                                                                    </button>
                                                                    <h2>₹{value?.price}</h2>
                                                                    <ul className="dropdown-menu" style={{}} aria-labelledby="dropdownMenuButton2">
                                                                        {value?.item_variations?.map((v,i)=>(
                                                                            <li><a className="dropdown-item something" href="#">{v?.product_weight} x 1 Pkt {value?.title} </a></li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div> */}
                  </div>
                  <div className="stati">
                    <p>
                      Contains healing enzymes, which repair dead skin
                      <br /> cells and make skin glow.
                    </p>
                  </div>
                  {/* <div className="iconpad1">
                                                            {value?.product_benefit?.map((v,i)=>(
                                                                <p><img src={`${image_url}${v?.icon}`} style={{height:'30px',width:'30px',marginRight:'10px'}} /> {v?.point}</p>
                                                            ))}
                                                        </div> */}
                  <div className="quality3button">
                    <Button title={`Add to cart (₹${value?.price})`} />
                    {/* <button>Add to cart (₹599)</button> */}
                    <p>Free 7-10 days delivery across India</p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-3"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div className="quality">
                  <div className="quality1">
                    <div className="dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton2"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {value?.["item_variations"] ? (
                          <p>
                            {value["item_variations"][0].product_weight}{" "}
                            <i className="fa-solid fa-angle-down"></i>
                          </p>
                        ) : (
                          <p>
                            Select Varient {console.log({ value })}
                            <i className="fa-solid fa-angle-down"></i>
                            <br />{" "}
                          </p>
                        )}
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton2"
                        style={{
                          maxWidth: "197px",
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                      >
                        {value?.item_variations?.map((v, i) => {
                          if (value?.item_variations?.length == 1) {
                            return (
                              <li
                                onClick={() => {
                                  selectVarient(v, value?.id);
                                }}
                              >
                                <a
                                  className="dropdown-item something1"
                                  style={{ borderRadius: "25px" }}
                                >
                                  <p>{v?.product_weight}</p>
                                </a>
                              </li>
                            );
                          } else if (i == 0) {
                            return (
                              <li
                                onClick={() => {
                                  selectVarient(v, value?.id);
                                }}
                              >
                                <a className="dropdown-item active something">
                                  <p>{v?.product_weight}</p>
                                </a>
                              </li>
                            );
                          } else if (i == value?.item_variations?.length - 1) {
                            return (
                              <li
                                onClick={() => {
                                  selectVarient(v, value?.id);
                                }}
                              >
                                <a className="dropdown-item something2">
                                  <p>{v?.product_weight}</p>
                                </a>
                              </li>
                            );
                          } else {
                            return (
                              <li
                                onClick={() => {
                                  selectVarient(v, value?.id);
                                }}
                              >
                                <a className="dropdown-item something1">
                                  <p>{v?.product_weight}</p>
                                </a>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className="quality2">
                    <p>Free 7-10 days delivery across India</p>
                  </div>
                  <div className="quality4">
                    <div className="quality3">
                      <h2>
                        ₹{value.price} {/*<s>800</s>*/}
                        <select
                          onChange={({ target }) => {
                            changeQnty(target?.value, value?.id);
                          }}
                          value={value?.qnty ? value?.qnty : 1}
                          style={{
                            width: "56px",
                            borderRadius: "15px",
                            fontSize: "16px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            backgroundColor: "white",
                            border: "0px",
                          }}
                        >
                          <option>
                            <span>
                              1 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              2 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              3 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              4 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              5 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              6 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              7 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              8 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              9 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                          <option>
                            <span>
                              10 <i className="fa-solid fa-angle-down"></i>
                            </span>
                          </option>
                        </select>
                      </h2>
                    </div>
                    <div className="quality4button">
                      <Button
                        onClick={() => {
                          addToCart(value);
                        }}
                        style={{ width: "100%", fontSize: 13 }}
                        backgroundColor={"#219653"}
                        title={`Add to cart (₹${
                          value?.price * parseInt(value?.qnty ? value?.qnty : 1)
                        })`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
  function SearchedRender({ searchedItems }) {
    return <>{<IterateOverItems items={searchedItems} />}</>;
  }

  function RenderItems({ currentPageItems }) {
    // console.log(currentPageItems, "from abhishek 110");
    return <>{<IterateOverItems items={currentPageItems} />} </>;
  }

  function PaginatedItems({ itemsPerPage }) {
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.

    const [itemOffset, setItemOffset] = useState(0);

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = List.slice(itemOffset, endOffset);

    const pageCount = Math.ceil(List.length / itemsPerPage);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % List.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };

    let searchItem = params?.searchKey;
    let newList = [];
    if (searchItem) {
      searchItem = searchItem.toLowerCase();

      List.forEach((l) => {
        if (l.title.toLowerCase().match(searchItem)) {
          newList.push(l);
        }
      });
    }
    return params?.searchKey === undefined ? (
      <>
        <RenderItems currentPageItems={currentItems} />

        <ReactPaginate
          className="pager"
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< Back"
          previousClassName={""}
          pageLinkClassName={"back3"}
          nextClassName={""}
          nextLinkClassName={"next"}
          previousLinkClassName={"next"}
          disabledLinkClassName={"back1"}
          activeLinkClassName={"back2"}
        />
      </>
    ) : (
      <>
        <SearchedRender searchedItems={newList} />
        <ReactPaginate
          className="pager"
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< Back"
          previousClassName={""}
          pageLinkClassName={"back3"}
          nextClassName={""}
          nextLinkClassName={"next"}
          previousLinkClassName={"next"}
          disabledLinkClassName={"back1"}
          activeLinkClassName={"back2"}
        />
      </>
    );
  }

  const changeQnty = (qnty, itemId) => {
    let list = [...List];
    const index = list?.findIndex((v) => v.id == itemId);

    if (index != -1) {
      list[index]["qnty"] = qnty;
    }

    setList(list);
  };

  const selectVarient = ({ id, product_weight, product_id }) => {
    let list = [...List];
    const index = list?.findIndex((v) => v.id == product_id);
    if (index != -1) {
      list[index]["varient_id"] = id;
      list[index]["product_weight"] = product_weight;
    }

    setList(list);
  };


  const truncate = (value, i) => {
    
    let aa =  <p
       style={{
         textAlign: "justify",
       }}
       dangerouslySetInnerHTML={{
         __html: value,
       }}
     ></p>;
   
    if (aa) {
      return `${value.substr(0, i)}...`;
    } else {
      return "";
    }
  };

  const SafeHTMLRenderer = (content,maxWords) => {
      const sanitizedContent = DOMPurify.sanitize(content);
      const contentWords = sanitizedContent.split(/\s+/);
      const truncatedWords = contentWords.slice(0, maxWords);
      const truncatedHTML = truncatedWords.join(" ");

    return (
      <div
        style={{
          textAlign: "justify",
        }}
        dangerouslySetInnerHTML={{
          __html: truncatedHTML,
        }}
      ></div>
    );
  };
  const getRating = (value) => {
    let Array = [];
    let lasti = 1;
    for (let i = 1; i < 6; i++) {
      if (value >= i) {
        Array.push(1);
      } else {
        Array.push(0);
      }
    }
    return Array;
  };
  return (
    <div className="best">
      <Header
        cartClick={() => {
          setrefres(!refres);
        }}
      />
      <div className="mizuki1">
        <span className="ipsum">
          <i className="fa-solid fa-left-long"></i>
        </span>
        <h1>Shop</h1>
        <span className="ipsum1">
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
      </div>

      <section>
        <div className="container-fluid">
          <div className="row background1">
            <Filter
              onFilter={(data) => {
                fetchItemList(data);
              }}
            />
            <div
              // className="col-md-10"
              style={{ marginTop: "50px", marginBottom: "50px", width: "80%" }}
            >
              <div className="homeshop">
                <div className="homelink">
                  <ul>
                    <li
                      onClick={() => {
                        navigate("/home");
                      }}
                    >
                      Home
                    </li>{" "}
                    <i
                      className="fa-solid fa-chevron-right"
                      style={{ marginRight: "5px" }}
                    ></i>
                    <li
                      onClick={() => {
                        navigate("/shoppage");
                      }}
                    >
                      <a href="#">shop</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="coupons">
                {/* <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">All</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Products</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Product Bundles</button>
                            </li>
                        </ul> */}
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="neel">
                      {List?.length == 0 && (
                        <div
                          style={{
                            fontSize: "30px",
                            fontWeight: "bold",
                            marginTop: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span>No Products Found!</span>
                        </div>
                      )}
                    </div>
                    <div className="neel"></div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    2
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-contact"
                    role="tabpanel"
                    aria-labelledby="pills-contact-tab"
                  >
                    3
                  </div>
                </div>
              </div>

              <div className="back">
                <PaginatedItems itemsPerPage={5} />

                {/* <ul className="pager">
              <li>
                <a href="#" className="back1">
                  <i className="fa-solid fa-angle-left"></i> Back
                </a>
              </li>
              <li>
                <a href="#" className="back2">
                  1
                </a>
              </li>
              <li>
                <a href="#" className="back3">
                  2
                </a>
              </li>
              <li>
                <a href="#" className="back4">
                  3
                </a>
              </li>
              <li>
                <a href="#" className="next">
                  Next <i className="fa-solid fa-angle-right"></i>
                </a>
              </li>
            </ul> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <CartModal refres={refres} show={true} />

      <div
        className="faqs"
        // style={{ display: "flex", flexDirection: "column" }}
      >
        <h2>FAQs</h2>
        <div
          class="tab-content"
          id="myTabContent"
          style={{ alignSelf: "center" }}
        >
          <div
            class="tab-pane fade active show"
            id="contact"
            role="tabpanel"
            aria-labelledby="contact-tab"
          >
            {faq?.map((v, i) => (
              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade active show"
                  id="contact"
                  role="tabpanel"
                  aria-labelledby="contact-tab"
                >
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingThree">
                        <button
                          className={`accordion-button collapsed ${
                            i === 0 ? "show" : ""
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseThree${i}`}
                          aria-expanded="false"
                          aria-controls={`collapseThree${i}`}
                        >
                          {v.title}
                        </button>
                      </h2>
                      <div
                        id={`collapseThree${i}`}
                        className={`accordion-collapse collapse ${
                          i === 0 ? "show" : ""
                        }`}
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">{v.description}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapComponent(ShopPage);
